import { Flex, HeaderWrapper, MainWrapper } from 'lib/components/styles/layout';
import { Heading } from 'lib/components/styles/typography';
import React, { useState } from 'react';
import { Button } from 'react-covideo-common';
import { HiPlus } from 'react-icons/hi';
import { MainContainer } from '../../index.styled';
import { LandingPageGroupFilters } from './LandingPageGroupFilters';
import { LandingPageGroupTable } from './LandingPageGroupTable';
import {
  ManageGroupsParams,
  useQueryGetGroupsWithFilters,
} from 'lib/api/superadmin/landingPageDesignGroups/useQueryGetGroupsWithFilters';
import { DEFAULT_PAGE, DEFAULT_SIZE } from 'lib/const/PaginationConstants';
import { BreadCrumbs } from 'lib/components/breadcrumbs/BreadCrumbs';
import CreateEditGroupModal from '../modals/CreateEditGroupModal';

export const LandingPageGroups = () => {
  const [selectedGroups, setSelectedGroups] = useState<(string | number)[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [limit, setLimit] = React.useState(DEFAULT_SIZE);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const params: ManageGroupsParams = {
    start: page * (limit || DEFAULT_SIZE),
    limit: limit || DEFAULT_SIZE,
    search: searchQuery,
    groupIds: selectedGroups as number[],
  };

  const {
    data: filteredGroupsData,
    isLoading,
    isFetching,
  } = useQueryGetGroupsWithFilters(params);
  const { data, count } = filteredGroupsData || { data: [], count: 0 };

  const onPaginationChange = async ({
    page: newPage,
    size: newSize,
  }: {
    page: number;
    size: number;
  }) => {
    setPage(newPage);
    setLimit(newSize);
  };

  const areGroupsLoading = isLoading || isFetching;
  const breadcrumbLinks = [
    {
      url: '/admin/landing-pages-v2',
      title: 'Landing Pages',
    },
    {
      url: '/admin/landing-pages-v2/manage-groups',
      title: 'Manage Groups',
    },
  ];

  return (
    <MainContainer>
      <MainWrapper resetPadding={false}>
        <BreadCrumbs links={breadcrumbLinks} />
        <Flex gap='40px'>
          <HeaderWrapper m='0px'>
            <Heading>Manage Groups</Heading>

            <Button
              text='Add New Group'
              icon={<HiPlus />}
              disabled={areGroupsLoading}
              onClick={() => {
                setIsCreateModalOpen(true);
              }}
            />
          </HeaderWrapper>

          <LandingPageGroupFilters
            searchQuery={searchQuery}
            onGroupSearchHandler={(value: string) => {
              setSearchQuery(value);
            }}
            setSelectedGroups={setSelectedGroups}
            isFetchingFilteredGroups={areGroupsLoading}
          />

          <Flex>
            <Heading>Groups</Heading>
            <LandingPageGroupTable
              data={data}
              count={count}
              onPaginationChange={onPaginationChange}
              isLoading={areGroupsLoading}
              page={page}
              limit={limit}
              searchQuery={searchQuery}
            />
          </Flex>
        </Flex>

        {isCreateModalOpen && (
          <CreateEditGroupModal onClose={() => setIsCreateModalOpen(false)} />
        )}
      </MainWrapper>
    </MainContainer>
  );
};
